import { z } from '@kc3/validation';
export const RECORDING_TYPES = ['all', 'inbound', 'outbound'];
export const TenantRecordingConfigSchema = z
    .object({
    recordingEnabled: z.boolean(),
    announcementEnabled: z.boolean(),
    announcementMessage: z.string().max(1000).nullable(),
    recordingType: z.enum(RECORDING_TYPES),
    retentionDays: z.number().int().min(1).max(3650).nullable(),
    allowAgentPause: z.boolean().default(false),
})
    .superRefine((v, ctx) => {
    if (v.announcementEnabled && !(v.announcementMessage ?? '').trim()) {
        ctx.addIssue({
            code: 'custom',
            path: ['announcementMessage'],
            message: 'Announcement message is required when the announcement is enabled',
        });
    }
});
export const DEFAULT_TENANT_RECORDING_CONFIG = {
    recordingEnabled: false,
    announcementEnabled: false,
    announcementMessage: null,
    recordingType: 'all',
    retentionDays: null,
    allowAgentPause: false,
};
//# sourceMappingURL=tenant-recording.js.map